import { Box } from '@material-ui/core';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';

const SubscriptionLogoStatus = ({
  classes,
  imageUrl,
  statusName,
  planImageList,
}) => (
  <Box>
    <Box className={classes.logoRowContainer}>
      <Box className={classes.logoContainer}>
        <img src={imageUrl} alt="F1Logo" className={classes.logo} />
      </Box>
      <Box className={classes.iconNode}>
        <CheckCircleRoundedIcon
          style={{ color: '#12c000', fontSize: '1.3rem', marginRight: '5px' }}
        />
        <span className={classes.iconText}>{statusName}</span>
      </Box>
    </Box>
    {planImageList?.isImageShown && (
      <Box pt={5}>
        <img
          className={planImageList.classOptions}
          src={planImageList.imageUrl}
          alt={planImageList.altText}
        />
      </Box>
    )}
  </Box>
);

export default SubscriptionLogoStatus;
